import { render, staticRenderFns } from "./PaymentMethodDeleteButton.vue?vue&type=template&id=2cd20ad8&scoped=true&"
import script from "./PaymentMethodDeleteButton.vue?vue&type=script&lang=ts&"
export * from "./PaymentMethodDeleteButton.vue?vue&type=script&lang=ts&"
import style0 from "./PaymentMethodDeleteButton.vue?vue&type=style&index=0&id=2cd20ad8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd20ad8",
  null
  
)

export default component.exports